module.exports = __webpack_public_path__ + "static/media/demo.ce164e80.gif";